import React  from 'react';
import Classes from "classnames";

export default function renderPercentageGroupListHeader(id, props) {
    const { data, className } = props;

    const notSet = _.isNil(data.value);
    const classes = Classes(className, 'gd-field-percentage-group-list-header', {
        'no-value': notSet
    });

    return (
        <div className={classes}>
            <div className="group-list-header-value">{!notSet ? data.value : "Not set"}</div>
            {!notSet && <div className="group-list-header-icon">%</div>}
        </div>
    );
}